// Local candidate support only. No network, tracker installation or cookie access.
(() => {
  'use strict';
  if(window.MaisonConsentSupport)return;
  const POLICY_VERSION=3, POLICY_HASH='sha256:0dd19edc901a2632a04793b8324eb358e7bc5041cf42aa371209e3234d89704f', MAX_AGE=180*86400000, LIMIT=100;
  const categories=['statistics','marketing','preferences'];
  const selection=v=>v&&categories.every(k=>typeof v[k]==='boolean');
  const copy=v=>selection(v)?Object.fromEntries(categories.map(k=>[k,v[k]])):null;
  const states=new Set(['pending','confirmed','failed','conflict','expired','blocked']);
  const actions=new Set(['accept-all','reject-all','save-selection','withdraw']);
  function createEvidence(storage,now=Date.now){
    const key='maison-consent-history-v1';
    function read(){
      const raw=storage.getItem(key);if(!raw)return {schema:1,entries:[],truncated:false};
      let data;try{data=JSON.parse(raw);}catch{throw Error('CONSENT_HISTORY_INVALID');}
      if(data.schema!==1||!Array.isArray(data.entries)||data.entries.length>LIMIT||typeof data.truncated!=='boolean')throw Error('CONSENT_HISTORY_INVALID');
      const entries=data.entries.map(e=>{
        if(!Number.isSafeInteger(e.sequence)||e.sequence<1||!Number.isFinite(e.at)||e.at>now()||!states.has(e.state)||!actions.has(e.action)||!/^sha256:[a-f0-9]{64}$/.test(e.policyHash)||!Number.isInteger(e.policyVersion)||!selection(e.requested)||(e.confirmed!==null&&!selection(e.confirmed)))throw Error('CONSENT_HISTORY_INVALID');
        return {sequence:e.sequence,at:e.at,state:e.state,action:e.action,policyVersion:e.policyVersion,policyHash:e.policyHash,requested:copy(e.requested),confirmed:copy(e.confirmed)};
      });
      if(entries.some((e,i)=>i&&e.sequence<=entries[i-1].sequence))throw Error('CONSENT_HISTORY_INVALID');
      return {schema:1,entries,truncated:data.truncated};
    }
    return Object.freeze({
      append({state,action,requested,confirmed}){
        if(!states.has(state)||!actions.has(action)||!selection(requested))throw Error('CONSENT_HISTORY_INPUT');
        const old=read(),sequence=(old.entries.at(-1)?.sequence??0)+1;
        if(!Number.isSafeInteger(sequence))throw Error('CONSENT_HISTORY_SEQUENCE_LIMIT');
        const entries=old.entries.filter(e=>now()-e.at<MAX_AGE);
        entries.push({sequence,at:now(),state,action,policyVersion:POLICY_VERSION,policyHash:POLICY_HASH,requested:copy(requested),confirmed:state==='confirmed'?copy(confirmed):null});
        const truncated=old.truncated||entries.length>LIMIT;
        const result={schema:1,truncated,entries:entries.slice(-LIMIT)};
        storage.setItem(key,JSON.stringify(result));
        return {sequence,truncated,policyHash:POLICY_HASH};
      },
      prune(){const data=read(),entries=data.entries.filter(e=>now()-e.at<MAX_AGE);if(entries.length!==data.entries.length)storage.setItem(key,JSON.stringify({...data,entries}));},
      export(){const data=read();return JSON.stringify({...data,entries:data.entries.filter(e=>now()-e.at<MAX_AGE),scope:'THIS_BROWSER_ONLY_NOT_SIGNED_SERVER_EVIDENCE'},null,2);}
    });
  }
  function createOwnedGate({allows}){
    if(typeof allows!=='function')throw Error('CONSENT_READER_REQUIRED');
    const adapters=new Map();let failed=false;
    function stop(a){a.active=false;try{a.stop();}catch{failed=true;}}
    const facade={
      register({id,category,verified=false,start,stop:stopFn}){
        if(!verified||!id||adapters.has(id)||!categories.includes(category)||typeof start!=='function'||typeof stopFn!=='function')throw Error('UNVERIFIED_OR_INVALID_OWNED_ADAPTER');
        adapters.set(id,{category,start,stop:stopFn,active:false});facade.reconcile();
      },
      reconcile(){
        for(const a of adapters.values()){
          if(failed||!allows(a.category)){if(a.active)stop(a);continue;}
          if(!a.active){try{a.start();a.active=true;}catch{failed=true;stop(a);}}
        }
        if(failed)for(const a of adapters.values())if(a.active)stop(a);
      },
      event(id,send){const a=adapters.get(id);if(!a||failed||!a.active||!allows(a.category))return false;send();return true;},
      dispose(){failed=true;for(const a of adapters.values())if(a.active)stop(a);},
      status:()=>({scope:'REGISTERED_OWNED_ADAPTERS_ONLY',failed,active:[...adapters].filter(([,a])=>a.active).map(([id])=>id)})
    };
    return Object.freeze(facade);
  }
  window.MaisonConsentSupport=Object.freeze({policyVersion:POLICY_VERSION,policyHash:POLICY_HASH,createEvidence,createOwnedGate});
})();
